//angular
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { FormGroup, FormArray, FormControl, Validators, FormBuilder, AbstractControl } from '@angular/forms';
//app
import { AppAnimations } from '../../../../../_shared/animations';
import { FilterOption, Filter, FilterRule } from '../../../../../_shared/models/filter.model';
import { responseCode } from '../../../../../app.data';
import { GridService, SkeletonLoaderService, LoaderService } from '../../../../../_core/services';
import { RestResponse } from '../../../../../_shared/models';
import { ValidatorService } from '../../../../../_shared/validators/validator.service';
import { KeyName } from 'src/app/app.keynames';
import * as dayjs from 'dayjs';
import { SharedGlobalService } from 'src/app/_core/services/api/shared-global.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'manage-filters',
  templateUrl: './manage-filters.component.html',
  animations: [AppAnimations]
})

export class DialogManageFiltersComponent implements OnInit, OnDestroy {
  collectionOfAllowValue: Array<any> = [];
  collectionOfAttribute: Array<FilterOption> = [];
  collectionOfOperator: Array<any> = [];
  collectionOfRule: FormArray = new FormArray([]);;
  filterAttribute: FilterOption = null;
  form: FormGroup;
  formSubmitted: boolean = false;
  deleteSubmitted: boolean = false;
  statusLoader: boolean;
  statusNewRulePanel: boolean = true;
  selectedAttributeID: number;
  selectedAttributeDisplayName: string;
  selectedAttributeOriginSource: string;
  selectedAttributeType: string;
  selectedOperatorId: number;
  selectedOperatorDisplayName: string;
  selectedOperatorName: string;
  selectedOperatorType: string = 'none';
  selectedValue: number;
  selectedValueDisplayName: string;
  selectedValueMultiList: Array<any> = [];
  isFiltersReady: boolean = false;
  isFiltersFieldsReady: boolean = false;
  private subs = new Unsubscriber();

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _dialogRef: MatDialogRef<DialogManageFiltersComponent>,
    private _fb: FormBuilder,
    public _grid: GridService,
    private _iconRegistry: MatIconRegistry,
    private _loader: LoaderService,
    private _meta: MetaService,
    private _sanitizer: DomSanitizer,
    public _skeleton: SkeletonLoaderService,
    private sharedGlobalService: SharedGlobalService,
    private ValidatorService: ValidatorService,
  ) {
    this._iconRegistry.addSvgIcon('ico-add-rule', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-add-02.svg'));
    this._iconRegistry.addSvgIcon('ico-delete-rule', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-delete-03.svg'));
  }

  setUpForm() {
    this.form = this._fb.group({
      ruleForm: this._fb.group({
        filterAttribute: ['', [Validators.required]],
        filterOperator: ['', [Validators.required]],
      }),
      displayName: ['', [Validators.required, this.ValidatorService.emptySpace, Validators.minLength(3), Validators.maxLength(255)]],
      section: [this._data.sectionId, [Validators.required]],
      isDefault: [false, [Validators.required]],
      rules: new FormArray([], [Validators.required])
    })
  }

  closePanel() {
    this._dialogRef.close();
  }

  getFilters() {
    this.subs.addSub = this.sharedGlobalService.getFilters(this._data.sectionId).subscribe(
      (res: RestResponse) => {
        this._grid.collectionOfFilter = <Array<Filter>>res.data;
        this.isFiltersReady = true;
      },
      (err: RestResponse) => {
        this.isFiltersReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  getFilterAttributes() {
    this.subs.addSub = this.sharedGlobalService.getFilterAttributesBySectionId(this._data.sectionId).subscribe(
      (res: RestResponse) => {
        this.collectionOfAttribute = <Array<FilterOption>>res.data;
        this.isFiltersFieldsReady = true;
      },
      (err: RestResponse) => {
        this.isFiltersFieldsReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  filterCollectionById(id: number, collection: Array<any>) {
    let filteredValue = collection.find(value => value.id == id);
    return filteredValue ? filteredValue : null;
  }

  ngOnInit() {
    this.setUpForm();
    this.getFilters();
    this.getFilterAttributes();
  }

  isDuplicatedRule(filterRule) {
    return this.form.get('rules').value.some(rule => rule.attributeId == filterRule.attributeId && rule.operatorId == filterRule.operatorId && rule.settingValues[0].value == filterRule.settingValues[0].value);
  }

  onAddRuleToFilter() {
    if (this.form.get('displayName').invalid) {
      this.form.get('displayName').markAsTouched();
      this.form.get('displayName').markAsDirty();

      if (this.form.get('ruleForm').invalid) {
        this.form.get('ruleForm').markAllAsTouched();
        this.form.get('ruleForm').markAsDirty();
        return;
      }
      return;
    } else if (this.form.get('ruleForm').invalid) {
      this.form.get('ruleForm').markAllAsTouched();
      this.form.get('ruleForm').markAsDirty();
      return;
    }

    let collectionOfFilterValue: Array<any> = [];

    if (this.selectedAttributeType == 'string' || this.selectedAttributeType == 'number' || this.selectedAttributeType == 'other') {
      if (this.selectedOperatorType == 'cb_text') {
        let objectValue: Object = {
          'displayName': this.form.get('ruleForm').get('filterValue').value,
          'value': this.form.get('ruleForm').get('filterValue').value,
        }
        collectionOfFilterValue.push(objectValue);
      } else if (this.selectedOperatorType == 'multi_select') {
        (this.form.get('ruleForm').get('filterValueMultiList').value).forEach(elem => {
          let objectValue: Object = {
            'displayName': elem.displayName ? elem.displayName : elem.name,
            'value': (this.selectedAttributeOriginSource == 'database' ? elem.id: elem.value)
          }
          collectionOfFilterValue.push(objectValue);
        });
      } else if (this.selectedOperatorType == 'list') {
        let objectValue: Object = {
          'displayName': (this.form.get('ruleForm').get('filterValueSingleList').value).displayName ? (this.form.get('ruleForm').get('filterValueSingleList').value).displayName : (this.form.get('ruleForm').get('filterValueSingleList').value).name,
          'value': (this.selectedAttributeOriginSource == 'database' ? (this.form.get('ruleForm').get('filterValueSingleList').value).id : (this.form.get('ruleForm').get('filterValueSingleList').value).value)
        }
        collectionOfFilterValue.push(objectValue);
      }
    } else if (this.selectedAttributeType == 'date') {
      if (this.selectedOperatorName == 'equals' || this.selectedOperatorName == 'before' || this.selectedOperatorName == 'after') {
        let objectValue: Object = {
          'displayName': dayjs(this.form.get('ruleForm').get('filterValue').value).format('MMM DD, YYYY'),
          'value': dayjs(this.form.get('ruleForm').get('filterValue').value).format('YYYY-MM-DD'),
        }

        collectionOfFilterValue.push(objectValue);
      } else if (this.selectedOperatorType == 'between') {
        // adds to the coollection of filters both starDate and endDate, this is because how weird is handled in the backend...
        let field: string;
        for (let i = 0; i <= 1; i++) {
          field = i == 0 ? 'startDate' : 'endDate';
          let objectValue: Object = {
            'displayName': dayjs(this.form.get('ruleForm').get(field).value).format('MMM DD, YYYY'),
            'value': dayjs(this.form.get('ruleForm').get(field).value).format('YYYY-MM-DD'),
          };
          collectionOfFilterValue.push(objectValue);
        }
      }
    }

    let filterRule: FilterRule = {
      'attributeId': this.selectedAttributeID,
      'attributeDisplayName': this.selectedAttributeDisplayName,
      'operatorId': this.selectedOperatorId,
      'operatorDisplayName': this.selectedOperatorDisplayName,
      'settingValues': collectionOfFilterValue
    };

    if (this.isDuplicatedRule(filterRule)) {
      this._meta.showNotificationCustomMessage(responseCode.errorBadRequestCode, KeyName.error_duplicated_rule_filter);
      return;
    }

    (<FormArray>this.form.get('rules')).push(new FormControl(filterRule));

    this.filterAttribute = null;
    this.selectedAttributeID = null
    this.selectedAttributeDisplayName = null;
    this.selectedAttributeOriginSource = null;
    this.selectedOperatorDisplayName = null;
    this.selectedOperatorId = null;
    this.selectedOperatorType = 'none';
    this.selectedValueMultiList = [];
    this.statusNewRulePanel = false;

    this.resetFormInput(this.form.get('ruleForm').get('filterAttribute'));
    this.resetFormInput(this.form.get('ruleForm').get('filterOperator'));
    this.clearSelectedFormTypeValue();
  }

  resetFormInput(input: AbstractControl) {
    if (input) {
      input.setValue('');
      input.markAsUntouched();
      input.markAsPristine();
      input.updateValueAndValidity();
    }
  }

  onCancelNewRule() {
    this.statusNewRulePanel = false;
    this.resetFormInput(this.form.get('ruleForm').get('filterAttribute'));
    this.resetFormInput(this.form.get('ruleForm').get('filterOperator'));
    this.clearSelectedFormTypeValue();
    this.clearSelectedOperator();
  }

  showNewRulePanel() {
    this.selectedOperatorType = 'none';
    this.statusNewRulePanel = true;
    this.resetFormInput(this.form.get('ruleForm').get('filterAttribute'));
    this.resetFormInput(this.form.get('ruleForm').get('filterOperator'));
    this.clearSelectedFormTypeValue();
    this.clearSelectedOperator();
  }

  onDeleteCustomFilter(_index,_filterId): void {
    this.deleteSubmitted = !this.deleteSubmitted;
    this.subs.addSub = this.sharedGlobalService.deleteCustomFilter(_filterId).subscribe(
      (res:RestResponse) => {
        this._grid.collectionOfFilter.splice(_index, 1);
        this.deleteSubmitted = !this.deleteSubmitted;
        this._meta.showNotification(res);
      },
      (err:RestResponse) => {
        this.deleteSubmitted = !this.deleteSubmitted;
        this._meta.showNotification(err);
      }
    );
  }

  onListValueChange($event) {
    this.form.get('ruleForm').get('filterValueSingleList').setValue($event.value);
  }

  onMultiListValueChange($event, option) {
    if ($event.checked) {
      (this.form.get('ruleForm').get('filterValueMultiList').value).push(option);
    } else {
      this.form.get('ruleForm').get('filterValueMultiList').setValue(this.form.get('ruleForm').get('filterValueMultiList').value.filter(value => value.id != option.id));
    }
    this.form.get('ruleForm').get('filterValueMultiList').updateValueAndValidity();
  }

  onRemoveRuleChip(index: number): void {
    const rules: FormArray = <FormArray>this.form.controls['rules'];
    if (rules.length > 0) {
      rules.removeAt(index)
      // There is no rules for the filter thus the new rule panel will be shown.
      if (rules.value.length < 1) {
        this.selectedOperatorType = 'none';
        this.statusNewRulePanel = true;
      }
    }
  }

  onSelectAttribute($event) {
    let attributeId = $event.value;
    this.selectedOperatorType = 'none';
    this.filterAttribute = this.filterCollectionById(attributeId, this.collectionOfAttribute);
    this.selectedAttributeType = this.filterAttribute.dataType;
    this.selectedAttributeID = attributeId;
    this.selectedAttributeDisplayName = this.filterAttribute.displayName;
    this.selectedAttributeOriginSource = this.filterAttribute.originSource;
    this.collectionOfOperator = this.filterAttribute.allowedOperators;
    this.resetFormInput(this.form.get('ruleForm').get('filterOperator'));
    this.clearSelectedFormTypeValue();
    this.clearSelectedOperator();
    this.setFormBasedOnTypeValue();
  }

  setFormBasedOnTypeValue() {
    if (this.selectedAttributeType == 'date')  {
      if (this.selectedOperatorName == 'equals' || this.selectedOperatorName == 'before' || this.selectedOperatorName == 'after') {
        if (!this.form.get('ruleForm').get('filterValue')) {
          (<FormGroup>this.form.get('ruleForm')).addControl('filterValue', new FormControl('', [Validators.required, this.ValidatorService.emptySpace, this.ValidatorService.doesntContainQuotes]));
        }
      } else if (this.selectedOperatorType == 'between') {
        if (!this.form.get('ruleForm').get('startDate')) {
          (<FormGroup>this.form.get('ruleForm')).addControl('startDate', new FormControl('', [Validators.required]));
        }
        if (!this.form.get('ruleForm').get('endDate')) {
          (<FormGroup>this.form.get('ruleForm')).addControl('endDate', new FormControl('', [Validators.required]));
        }
      }
    } else if (this.selectedAttributeType == 'string' || this.selectedAttributeType == 'number' || this.selectedAttributeType == 'other') {
      if (this.selectedOperatorType == 'cb_text') {
        if (!this.form.get('ruleForm').get('filterValue')) {
          (<FormGroup>this.form.get('ruleForm')).addControl('filterValue', new FormControl('', [Validators.required, this.ValidatorService.emptySpace, this.ValidatorService.doesntContainQuotes]));
        }
      } else if (this.selectedOperatorType == 'multi_select') {
        if (!this.form.get('ruleForm').get('filterValueMultiList')) {
          (<FormGroup>this.form.get('ruleForm')).addControl('filterValueMultiList', new FormControl([], [Validators.required]));
        }
      } else if (this.selectedOperatorType == 'list') {
        if (!this.form.get('ruleForm').get('filterValueSingleList')) {
          (<FormGroup>this.form.get('ruleForm')).addControl('filterValueSingleList', new FormControl('', [Validators.required]));
        }
      }
    }
  }

  clearSelectedFormTypeValue() {
    if (this.form.get('ruleForm').get('filterValue')) {
      (<FormGroup>this.form.get('ruleForm')).removeControl('filterValue');
    }
    if (this.form.get('ruleForm').get('startDate')) {
      (<FormGroup>this.form.get('ruleForm')).removeControl('startDate');
    }
    if (this.form.get('ruleForm').get('endDate')) {
      (<FormGroup>this.form.get('ruleForm')).removeControl('endDate');
    }
    if (this.form.get('ruleForm').get('filterValueMultiList')) {
      (<FormGroup>this.form.get('ruleForm')).removeControl('filterValueMultiList');
    }
    if (this.form.get('ruleForm').get('filterValueSingleList')) {
      (<FormGroup>this.form.get('ruleForm')).removeControl('filterValueSingleList');
    }
    this.form.get('ruleForm').updateValueAndValidity();
  }

  clearSelectedOperator() {
    this.selectedOperatorId = 0;
    this.selectedOperatorType = '';
    this.selectedOperatorName = '';
    this.selectedOperatorDisplayName = '';
  }

  onSelectOperator($event) {
    let operatorId = $event.value;
    let operatorSelected = this.filterCollectionById(operatorId, this.collectionOfOperator);
    this.selectedOperatorId = operatorId;
    this.selectedOperatorType = operatorSelected.type;
    this.selectedOperatorName = operatorSelected.name;
    this.selectedOperatorDisplayName = operatorSelected.displayName;
    this.collectionOfAllowValue = this.filterAttribute.allowedValues;
    this.clearSelectedFormTypeValue();
    this.setFormBasedOnTypeValue();
  }

  createFilter(_bodyParams: any) {
    this.subs.addSub = this.sharedGlobalService.createFilter(_bodyParams).subscribe(
      (res: RestResponse) => {
        this._dialogRef.close(res);
      },
      (err: RestResponse) => {
        this.formSubmitted = !this.formSubmitted;
        this._meta.showNotification(err);
      }
    );
  }

  onSubmit() {
    this.formSubmitted = !this.formSubmitted;

    if (this.form.get('displayName').invalid) {
      this.form.get('displayName').markAsTouched();
      this.form.get('displayName').markAsDirty();
      this.formSubmitted = !this.formSubmitted;
      return;
    }

    this._loader.startPageLoader();
    let bodyParams = {
      displayName: this.form.value.displayName,
      section: this.form.value.section,
      isDefault: this.form.value.isDefault,
      rules: this.form.value.rules
    };

    if(bodyParams.rules.some(item => item.operatorDisplayName == 'between')) {
      bodyParams.rules.find(item => {
        if(item.operatorDisplayName == 'between') {
          let filterRule: FilterRule = {
            'attributeId': item.attributeId,
            'attributeDisplayName': item.attributeDisplayName,
            'operatorId': item.operatorId,
            'operatorDisplayName': item.operatorDisplayName,
            'settingValues': [item.settingValues.splice(1,1)[0]]
          };
          bodyParams.rules.push(filterRule);
        }
      })
    }

    console.log('bodyParams', bodyParams)
    this.createFilter(bodyParams);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
